import { Countdown } from '../components/Countdown';
import { Reveal } from '../components/Reveal';
import { Rule } from '../components/Rule';
import { couple, day, invitation } from '../content/wedding';

export function Invitation() {
  return (
    <section class="section invite" id="invitation">
      <div class="shell">
        <Reveal>
          <span class="eyebrow">
            {day.weekday}, {day.dateLong}, {day.yearLong}
          </span>
        </Reveal>

        <Reveal delay={120}>
          <p class="invite__lines" style={{ marginTop: '1.75rem' }}>
            {invitation.map((line) => (
              <span key={line}>{line}</span>
            ))}
          </p>
        </Reveal>

        <Reveal delay={220}>
          <p class="serif-lead" style={{ marginTop: '2rem' }}>
            — {couple.one.first} &amp; {couple.two.first}
          </p>
        </Reveal>

        <Reveal delay={280}>
          <Rule class="invite__rule" />
        </Reveal>

        <Reveal delay={120} class="invite__count">
          <Countdown />
        </Reveal>
      </div>
    </section>
  );
}
